'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _es6Promise = require('es6-promise');

var _getHeaders = require('get-headers');

var _response = require('../response');

var _response2 = _interopRequireDefault(_response);

var _headers = require('../headers');

var _headers2 = _interopRequireDefault(_headers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 @module http/browser
 */

var httpBrowser = function httpBrowser(request) {

  return new _es6Promise.Promise(function (resolve, reject) {

    var req = new XMLHttpRequest();
    var timer = void 0;

    req.open(request.method, request.url, true);

    _.map(request.headers.map, function (value, key) {

      req.setRequestHeader(key, value.join(','));
    });

    req.send(request._bodyInit);

    req.addEventListener('load', function () {

      var headers = new _headers2.default((0, _getHeaders.parse)(req.getAllResponseHeaders()));
      var urlList = req.responseURL && request.url === decodeURI(req.responseURL) ? [request.url] : [request.url, decodeURI(req.responseURL)];

      if (request.timeout) clearTimeout(timer);

      return resolve(new _response2.default(req.responseText, {
        urlList: urlList,
        status: req.status,
        statusText: req.statusText,
        headers: headers
      }));
    });

    if (request.timeout) {

      timer = setTimeout(function () {

        req.abort();

        return reject(new Error('Fetch timeout exceeded'));
      }, request.timeout);
    }
  });
};

exports.default = httpBrowser;